import { createAction, createReducer } from "@reduxjs/toolkit";
import { updateProviderStudio } from "./update-provider-studio";
import type { ProcessingState } from "@redux/state/shared-types";

const initialState: ProcessingState = {
  processing: "idle",
};

export const resetUpdateProviderStudio = createAction("provider/studio/resetUpdate");

export const updateProviderStudioReducer = createReducer(initialState, builder => {
  builder
    .addCase(updateProviderStudio.pending, state => {
      state.processing = "pending";
    })
    .addCase(updateProviderStudio.fulfilled, state => {
      state.processing = "success";
    })
    .addCase(updateProviderStudio.rejected, state => {
      state.processing = "failed";
    })
    .addCase(resetUpdateProviderStudio, () => {
      return initialState;
    });
});
